// var app = new Vue({
//   el: '#app',
//   data: {
//     message: 'Hello Vue!'
//   }
// })


$(document).ready(function(){

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    // pagination();

    $("#shopify-section-customer-blocks .terms-titles a[data-block='3']").attr('href', 'https://www.project213a.com/blogs/press')

    // header

    $('[data-value=EUR]').html('EUR (€)')

    $('.header .menu-closed').click(function(e){
        e.preventDefault();
        $('.drawer-menu').addClass('visible')
        $('.header').addClass('menu-open')
        $('body').css('overflow', 'hidden')
    })

    $('.header .menu-open').click(function(e){
        e.preventDefault();
        $('.drawer-menu').removeClass('visible')
        $('.header').removeClass('menu-open')
        $('body').css('overflow', 'auto')
    })


    $('.projects-head-mobile--head').click(function(){
        $('.projects-head-mobile').toggleClass('open')
    })

    $('.projects-head-mobile .projects-types-submenu .toggler').click(function(){
        $('.projects-head-mobile .projects-types-submenu-children').hide();
        $(this).parent().find('.projects-types-submenu-children').show();
    })

    // quick cart

    if (urlParams.get('cart') === 'open') {
        $('.quick-cart').addClass('visible')
    }    

    $('.quick-cart-open').click(function(){
        $('.quick-cart').addClass('visible')
    })
    $('.quick-cart__overlay').click(function(){
        $('.quick-cart').removeClass('visible')
    })
    
    //// update cart


    function updateCart(variantId, qty) {
        const updates = {};
        updates[variantId] = qty;

        $.post("/cart/update.js", { updates })
            .done(function () {
                // Optional: Refresh the page with cart open
                const url = window.location.href.split('?')[0] + '?cart=open';
                window.location.href = url;
            });
    }

    function updateQuantity(input, newQty) {
        const variantId = $(input).attr('id');
        const max = parseInt($(input).attr('max'), 10);

        // Clamp quantity
        if (!isNaN(max)) {
            newQty = Math.min(newQty, max);
        }
        newQty = Math.max(0, newQty);

        $(input).val(newQty);
        updateCart(variantId, newQty);
    }

    // Handle up/down buttons
    $('.qty-button').click(function () {
        const input = $(this).siblings('input');
        let currentQty = parseInt(input.val(), 10) || 0;
        const direction = $(this).data('qty');

        if (direction === 'up') {
            currentQty++;
        } else if (direction === 'down' && currentQty > 0) {
            currentQty--;
        }

        updateQuantity(input, currentQty);
    });

    // Handle manual input changes
    $('.product-form__input--quantity').on('change', function () {
        let newQty = parseInt($(this).val(), 10) || 0;
        updateQuantity(this, newQty);
    });

    // Handle remove button
    $('.cart-remove').click(function () {
        const variantId = $(this).data('id');
        updateCart(variantId, 0);
    });


    // location.reload();


    // home landing

    var random = Math.floor(Math.random() * jQuery('.home-landing-main img').length);
    jQuery('.home-landing-main img').hide().eq(random).show();



    // term pages

    if (window.location.hash) {
        var termhash = window.location.hash;
        var term = termhash.replace("#", "");
        $('.terms .terms-text-block[data-block=' + term + ']').addClass('active');
        $('.terms .terms-titles a[data-block=' + term + ']').addClass('active');
    } else {
        $('.terms .terms-text-block:first-child').addClass('active');
        $('.terms .terms-titles a:first-child').addClass('active');        
    }

    $('.terms .terms-titles a').click(function(){
        if (!$(this).attr('href')) {
            $('.terms .terms-text-block').removeClass('active');
            $('.terms .terms-titles a').removeClass('active');
            $(this).addClass('active');
            var count = $(this).data('block');
            window.location.hash = count;
            $('.terms .terms-text-block[data-block=' + count + ']').addClass('active')
        }
    })
 


    // product info


    $('.product-form-info-tabs-item').click(function(){
        $('.product-form-info-content-item').removeClass('active');
        $('.product-form-info-tabs-item').removeClass('active');
        $(this).addClass('active');
        var count = $(this).data('block');
        $('.product-form-info-content-item[data-block=' + count + ']').addClass('active')
    })


    // product swatches

    // $('.product-form-color-swatches a:nth-child(1)').addClass('active')
    // $('.product-form-color-swatches a').click(function(e){
    //     e.preventDefault();
    //     var cor = $(this).data('product-swatch-option');
    //     $('.product-form-color-swatches a').removeClass('active')
    //     $(this).addClass('active')
    //     $('.special-swatches option[data-swatch=' + cor + ']').prop('selected', 'selected').change();
    // })

    var $slider = $('.product-slider');
    var $counter = $('.slide-counter');

    $slider.on('init', function(event, slick){
        var totalSlides = slick.slideCount;
        $counter.text('1/' + totalSlides);
    });

    $slider.on('afterChange', function(event, slick, currentSlide){
        var currentSlideIndex = currentSlide + 1;
        var totalSlides = slick.slideCount;
        $counter.text(currentSlideIndex + '/' + totalSlides);
    });


    // product slider
    $('.product-slider').slick({
        dots: true,
        infinite: false,
        prevArrow:"<img class='slick-prev' src='https://www.project213a.com/cdn/shop/t/11/assets/arrow_left.png?v=174771305305799707011733400659'>",
        nextArrow:"<img class='slick-next' src='https://www.project213a.com/cdn/shop/t/11/assets/arrow_right.png?v=96447540730453074211733400662'>",
        //prevArrow:"<svg class='slick-prev' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='30px' height='17px' viewBox='0 0 30 17' version='1.1'><g id='P213A-Design' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='square'><g id='PDP' transform='translate(-570.000000, -377.000000)' stroke='#000000'><g id='Group-12' transform='translate(570.000000, 377.000000)'><line x1='29.5' y1='8.5' x2='21.5' y2='0.5' id='Line-9'/><line x1='29.5' y1='9' x2='21.5' y2='17' id='Line-9'/><line x1='0.5' y1='8.5' x2='29.5' y2='8.5' id='Line-8'/></g></g></g></svg>",
        // nextArrow:"<svg class='slick-next' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='30px' height='17px' viewBox='0 0 30 17' version='1.1'><g id='P213A-Design' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='square'><g id='PDP' transform='translate(-570.000000, -377.000000)' stroke='#000000'><g id='Group-12' transform='translate(570.000000, 377.000000)'><line x1='29.5' y1='8.5' x2='21.5' y2='0.5' id='Line-9'/><line x1='29.5' y1='9' x2='21.5' y2='17' id='Line-9'/><line x1='0.5' y1='8.5' x2='29.5' y2='8.5' id='Line-8'/></g></g></g></svg>",
        customPaging: function(slick,index) {
            return '<a>' + (index + 1) + '</a>';
        }
    });

    $('.slide-close').click(function(){
        $('.product-slider, .product__media-container').removeClass('gallery');
    })

    if ($(window).width() < 768) {
        $('.product-slider .slick-slide img').click(function(){
            $('.product-slider, .product__media-container').addClass('gallery');
        })
    }

    $('.projects .sorter-item').each(function(){
        var sorter = $(this).data('sort')
        if (location.search === '?sort_by=' + sorter) {
            $(this).addClass('active')
        } else if (location.search === '') {
            $('.sorter-item.default').addClass('active')
        }
    })

    $('.projects .projects-types a').each(function(){
        var url = window.location.pathname;
        var sorter = $(this).attr('href')
        if (sorter === url) {
            $(this).addClass('active')
        }
    })

    $('.projects .sorter-item').click(function(){
        var sorter = $(this).data('sort')
        location.search = '?sort_by=' + sorter
    })

    $('.projects .sorter-list-toggle').click(function(event){
        event.stopPropagation();
        $('.projects .sorter-list').addClass('open')
    })

    $(window).click(function() {
        $('.projects .sorter-list').removeClass('open')
    })


    // product page

    $('.qty-box .qty-btn').on('click', function(){
        var qty = parseInt($(this).parent('.qty-box').find('.product-form__input').val());
        if($(this).hasClass('qty-plus')) {
          qty++;
        }else {
          if(qty > 1) {
            qty--;
          }
        }
        qty = (isNaN(qty))?1:qty;
        $(this).parent('.qty-box').find('.product-form__input').val(qty);
      }); 
      
      
      // recover pass

      $('.recoverpass').click(function(){
        $('.login-form-login').fadeOut( "slow", function() {
            $('.login-form-reset').fadeIn()
        });
      });
      $('.cancelreset').click(function(){
        $('.login-form-reset').fadeOut( "slow", function() {
            $('.login-form-login').fadeIn()
        });
      });
          

    if (urlParams.get('product')) {
        const productTitle = urlParams.get('product');
        const productUrl = urlParams.get('url');

        // Set the visible link
        $('#ProductInfoLink').html(`<a href="${productUrl}" target="_blank">${productTitle}</a>`);

        // Set the hidden input value for form submission as plain text
        $('#ProductInfoHidden').val(`${productTitle}: https://www.project213a.com/${productUrl}`);
    }





    // // text filter
    // $('input#filtersearch').on('keyup',function(){
    //     var searchTerm = $(this).val().toLowerCase();
    //     $('.product-item').each(function(){
    //         var lineStr = $(this).text().toLowerCase();
    //         if(lineStr.indexOf(searchTerm) === -1){
    //             $(this).hide();
    //             $(this).removeClass('searchShow')
    //             $(this).removeClass('unfade')
    //         }else{
    //             $(this).show();
    //             $(this).addClass('searchShow')
    //             $(this).addClass('unfade')
    //         }
    //     });
    //     pagination()
    // });

    // blog slider

    // $('.blog__articles').slick({
    //     infinite: true,
    //     dots: false,
    //     variableWidth: false,
    //     prevArrow:"<div class='slick-prev'><img src='https://www.project213a.com/cdn/shop/t/11/assets/arrow_left.png?v=174771305305799707011733400659'></div>",
    //     nextArrow:"<div class='slick-next'><img src='https://www.project213a.com/cdn/shop/t/11/assets/arrow_right.png?v=96447540730453074211733400662'></div>",
    // });

   function updateProjectTitle() {
      var windowHeight = $(window).height();
      var scrollPosition = $(window).scrollTop();
      var lastArticle = $(".blog__article").last();
      var lastArticleBottom = lastArticle.offset().top + lastArticle.outerHeight();

      // Check if scrolled 50px past the last article
      if (scrollPosition + windowHeight > lastArticleBottom + 50) {
        $(".projects-types a").removeClass("active").hide();
        return;
      }

      $(".blog__article").each(function (index) {
        var articleTop = $(this).offset().top;
        var articleBottom = articleTop + $(this).outerHeight();

        // Show corresponding title when article is 90px from bottom of viewport
        if (scrollPosition + windowHeight - 90 >= articleTop && scrollPosition + 50 < articleBottom) {
          $(".projects-types a").removeClass("active").hide();
          $(".projects-types a").eq(index).show().addClass("active");
        }
      });
    }

    // Run on page load and scroll
    if ($('.blog__articles').length) {
        updateProjectTitle();
        $(window).on("scroll", updateProjectTitle);
    }

    $('.blog .projects-types a').on('click', function (e) {
        e.preventDefault(); // Prevent default link behavior

        // Get the index of the clicked menu item
        let slideIndex = $(this).index();

        // Update active class
        $('.blog .projects-types a').removeClass('active');
        $(this).addClass('active');

        // Go to the corresponding slide
        $('.blog__articles').slick('slickGoTo', slideIndex);
    });

    // Sync active class when slider changes
    $('.blog__articles').on('afterChange', function (event, slick, currentSlide) {
        // Remove active class from all menu items
        $('.blog .projects-types a').removeClass('active');

        // Add active class to the corresponding menu item
        $('.blog .projects-types a').eq(currentSlide).addClass('active');
    });

    $('.article__slideshow').slick({
        infinite: true,
        dots: false,
        variableWidth: false,
        prevArrow:"<div class='slick-prev'><img src='https://www.project213a.com/cdn/shop/t/11/assets/arrow_left.png?v=174771305305799707011733400659'></div>",
        nextArrow:"<div class='slick-next'><img src='https://www.project213a.com/cdn/shop/t/11/assets/arrow_right.png?v=96447540730453074211733400662'></div>",
        // responsive: [
        //     {
        //     breakpoint: 767,
        //     settings: "unslick"
        //     }
        // ]
    });
    
    
})

//collection pagination
var pagination = function() {
    
    $("#pagin").html('')

	pageSize = 24;

	var pageCount =  $("#content .product-item.searchShow").length / pageSize;
    
     for(var i = 0 ; i<pageCount;i++){
        
       $("#pagin").append('<li class="pagination__item"><a class="link">'+(i+1)+'</a><li>');
     }
        $("#pagin li").first().find("a").addClass("pagination__item--active")
        showPage = function(page) {
	    $("#content .product-item").hide();
	    $("#content .product-item.searchShow").each(function(n) {
	        if (n >= pageSize * (page - 1) && n < pageSize * page)
	            $(this).show();
	    });        
	}
    
	showPage(1);


	$("#pagin li a").click(function() {
	    $("#pagin li a").removeClass("pagination__item--active");
	    $(this).addClass("pagination__item--active");
        window.scrollTo(0, 0); 
	    showPage(parseInt($(this).text())) 
	});


    
}

window.onhashchange = function() {
    location.reload();       // ## reload page
}

    
    
    
    
$(document).ajaxComplete(function(){

    // money fix

    $('.money').each(function(){
        let tmp = $(this).text()
        let newstring = tmp.substring(1);
        let cara = tmp.slice(0,1)
        if (!$.isNumeric(cara)) {
            $(this).text(newstring)
            $(this).css('opacity', 1)
        }
    })

    $('.currency-switcher .list').click(function() {
        $('.money').css('opacity', 0)
        setTimeout(() => { 
            $('.money').each(function(){
                let tmp = $(this).text()
                let newstring = tmp.substring(1);
                let cara = tmp.slice(0,1)
                if (!$.isNumeric(cara)) {
                    $(this).text(newstring)
                    $('.money').css('opacity', 1)
                }
            })
        }, 800);
    })

    // menu currency
     $('[data-display=EUR').text('EUR (€)').css('color', '#444444')
     $('[data-display=GBP').text('GBP (£)').css('color', '#444444')
     $('[data-display=USD').text('USD ($)').css('color', '#444444')
     $('.flags-United-States').parent().text('USD ($)')
     $('.flags-European-Union').parent().text('EUR (€)')
     $('.flags-United-Kingdom').parent().text('GBP (£)')

});




$(window).on('load', function(){ 
    // // home landing 
    // $('.home-landing').addClass('active')    
    // setTimeout(() => { 
    //     $('body.template-index').css('overflow', 'auto')
    //     $('.home-landing').addClass('close')
    //     setTimeout(() => { 
    //         $('.home-landing-main').hide()            
    //     }, 400);
    //     setTimeout(() => { 
    //         $('.home-landing').hide()            
    //     }, 800);
    // }, 2500);
});

$(window).scroll(function() {
    // let image = $(".spinner");
    // $(".spinner").css("transform", "rotate(" + window.pageYOffset/10 + "deg)");
    
    if ($(window).width() > 767) {
        $('.fademe').each( function(i){
            var bottom_of_object = $(this).offset().top + $(this).outerHeight() - 200;
            var bottom_of_window = $(window).scrollTop() + $(window).height();
            /* If the object is completely visible in the window, fade it it */
            if( bottom_of_window > bottom_of_object ){
                $(this).addClass('unfade');
            }
        }); 
    } else {
        $('.fademe').addClass('unfade')
    }
});

// product function 


$(document).on('click','.product-form__cart-submit',function(){
var quantity = $("#Quantity-product--static").val();
var id= $('.special-swatches').val(); 
console.log(quantity + id)   
$.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {id:id,quantity:quantity},
    dataType: 'json', 
    success: function (data) { 
        location.reload();
    },
    error: function (xhr, status, error) {
        var err = JSON.parse(xhr.responseText);
        $(".cart-error").text(err.description);
    }
});
});   


$(window).on('load', function() {
    adjustArrowWidth(); // Manually adjust on page load
});


